'use client';

import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import { PropsWithChildren } from 'react';

import { makeClient } from '@/utils/apollo/makeClient';

export const ApolloProvider = ({
  children,
  locale,
  ssrCookie
}: PropsWithChildren<{ locale: string; ssrCookie: string }>) => {
  return (
    <ApolloNextAppProvider makeClient={() => makeClient(locale, ssrCookie)}>
      {children}
    </ApolloNextAppProvider>
  );
};
